function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import colors from "styles/colors";
import { DARK_WORK_OS_IRIS_COLOR_NAME, SPACE_BLUE_COLOR_NAME } from "styles/color-consts";
import { getUrlWithColor } from "services/community/cloudinary-service";
import classnames from "classnames";
import AssetComponent from "components/core/asset/asset-component";
import { trackEvent } from "services/bigbrain-service";
import { TAB_CLICKED } from "constants/bigbrain-event-types";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { productsColorOptionsOvertonesMap } from "constants/color-picker-constants";
import { StyledBuildingBlocksTabComponent } from "./building-blocks-tab-component.scss";
const DEFAULT_ICON_SIZE = "16px";
const BuildingBlocksTabComponent = (props)=>{
    var _productsColorOptionsOvertonesMap_themeColor;
    const { buildingBlock, index, selectedTab, setSelectedTab, themeColor } = props;
    const isSelected = index === selectedTab;
    const tabSelectedColor = colors[((_productsColorOptionsOvertonesMap_themeColor = productsColorOptionsOvertonesMap[themeColor]) === null || _productsColorOptionsOvertonesMap_themeColor === void 0 ? void 0 : _productsColorOptionsOvertonesMap_themeColor.dark) || DARK_WORK_OS_IRIS_COLOR_NAME];
    const getTabIconAsset = ({ isSelected })=>{
        return {
            image: {
                src: getUrlWithColor({
                    url: buildingBlock.tabIcon,
                    color: isSelected ? tabSelectedColor : colors[SPACE_BLUE_COLOR_NAME]
                })
            }
        };
    };
    const selectedTabIconAsset = getTabIconAsset({
        isSelected: true
    });
    const unselectedTabIconAsset = getTabIconAsset({
        isSelected: false
    });
    const selectTab = ({ buildingBlock, index })=>{
        var _buildingBlock_videoPlayerRef;
        trackEvent(TAB_CLICKED, {
            kind: buildingBlock.tabLabel,
            info1: index
        });
        setSelectedTab(index);
        // start video at 0 time
        if (buildingBlock === null || buildingBlock === void 0 ? void 0 : (_buildingBlock_videoPlayerRef = buildingBlock.videoPlayerRef) === null || _buildingBlock_videoPlayerRef === void 0 ? void 0 : _buildingBlock_videoPlayerRef.current) {
            buildingBlock.videoPlayerRef.current.seekTo(0);
        }
    };
    return /*#__PURE__*/ _jsxs(StyledBuildingBlocksTabComponent, {
        className: classnames("tab", {
            selected: isSelected
        }),
        onClick: ()=>selectTab({
                buildingBlock,
                index
            }),
        onKeyDown: generateOnKeyDownHandler(()=>selectTab({
                buildingBlock,
                index
            })),
        role: "tab",
        "aria-selected": isSelected,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "icon-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("icon-absolute-container", {
                            visible: isSelected
                        }),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, selectedTabIconAsset), {
                            width: DEFAULT_ICON_SIZE,
                            height: DEFAULT_ICON_SIZE
                        }))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("icon-absolute-container", {
                            visible: !isSelected
                        }),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, unselectedTabIconAsset), {
                            width: DEFAULT_ICON_SIZE,
                            height: DEFAULT_ICON_SIZE
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "name",
                style: {
                    color: isSelected ? tabSelectedColor : colors[SPACE_BLUE_COLOR_NAME]
                },
                children: buildingBlock.tabLabel
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "marker",
                style: {
                    backgroundColor: isSelected ? tabSelectedColor : "transparent"
                }
            })
        ]
    }, index);
};
export default BuildingBlocksTabComponent;
